import { executeGetNoResultError } from '../common/apiCaller'
import { GetResidenceCategoryMstDto } from '../dto/residenceCategoryMstDto'

const apiName = 'public'
const apiPath = '/residence-category-mst'

export const executeGetResidenceCategoryMst = async () => {
  return executeGetNoResultError<GetResidenceCategoryMstDto>(apiName, apiPath)
}
